import { Fragment } from 'react';

import { parseTags, type Tags } from './parseTags';

interface Props {
  /**
   * The resolved text to render, e.g. `text={getText('some.fms.key')}`.
   * Wrap segments in named tags to have them rendered by `tags`, e.g.
   * `hello this is a <link>link</link> from somewhere.`.
   */
  text: string;
  /**
   * Map of tag name to a render function, mirroring `react-intl`'s
   * `FormattedMessage` rich-text tags. Each function receives the tag's inner
   * content, e.g. `{ link: (chunks) => <a href="...">{chunks}</a> }`.
   */
  tags: Tags;
}

export function FormatText({ text, tags }: Props) {
  return <Fragment>{parseTags(text, tags)}</Fragment>;
}

export type { Tags, TagRenderer } from './parseTags';
